(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-category-shop-v3"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGCSC3(root) {
    if (!root || root.dataset.gcsc3Init === '1') return;
    root.dataset.gcsc3Init = '1';

    var layout = root.dataset.layout;
    var filterEnabled = root.dataset.filter === 'true';
    var autoplay = root.dataset.autoplay === 'true';
    var autoplaySpeed = parseFloat(root.dataset.autoplaySpeed || '4') * 1000;

    var track = root.querySelector('.gcsc3-track');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-gcsc3-category]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.gcsc3-panel'));
    var prevBtn = root.querySelector('.gcsc3-arrow-prev');
    var nextBtn = root.querySelector('.gcsc3-arrow-next');
    var dotsWrap = root.querySelector('.gcsc3-dots');

    var currentIndex = 0;
    var autoplayTimer = null;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isDragging = false;

    function getVisibleCount() {
      var w = window.innerWidth;
      if (w >= 990) return parseInt(getComputedStyle(root).getPropertyValue('--gcsc3-cols-desktop')) || 1;
      if (w >= 750) return parseInt(getComputedStyle(root).getPropertyValue('--gcsc3-cols-tablet')) || 1;
      return parseInt(getComputedStyle(root).getPropertyValue('--gcsc3-cols-mobile')) || 1;
    }

    function getRows() {
      return parseInt(getComputedStyle(root).getPropertyValue('--gcsc3-rows')) || 1;
    }

    function totalSlides() {
      var perSlide = getVisibleCount() * getRows();
      return Math.max(1, Math.ceil(cards.length / perSlide));
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var total = totalSlides();
      for (var i = 0; i < total; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'الشريحة ' + (i + 1));
        if (i === 0) b.classList.add('is-active');
        (function (idx) {
          b.addEventListener('click', function () { goToSlide(idx); resetAutoplay(); });
        })(i);
        dotsWrap.appendChild(b);
      }
    }

    function updateDots(slideIndex) {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('button');
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === slideIndex); });
    }

    function updateArrows() {
      var total = totalSlides();
      if (prevBtn) prevBtn.disabled = total <= 1;
      if (nextBtn) nextBtn.disabled = total <= 1;
    }

    function goToSlide(slideIndex) {
      if (layout !== 'carousel' || !track || !cards.length) return;
      var visible = getVisibleCount();
      var total = totalSlides();
      currentIndex = ((slideIndex % total) + total) % total;
      var colWidth = cards[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(root).getPropertyValue('--gcsc3-gap')) || 0;
      var offset = currentIndex * visible * (colWidth + gap);
      track.style.transform = 'translateX(' + offset + 'px)';
      updateDots(currentIndex);
    }

    function resetAutoplay() {
      if (!autoplay || reducedMotion) return;
      clearInterval(autoplayTimer);
      autoplayTimer = setInterval(function () {
        if (!isDragging) goToSlide(currentIndex + 1);
      }, autoplaySpeed);
    }

    if (layout === 'carousel' && cards.length) {
      requestAnimationFrame(function () {
        buildDots();
        updateArrows();
        goToSlide(0);
        resetAutoplay();
      });

      if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentIndex + 1); resetAutoplay(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentIndex - 1); resetAutoplay(); });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          buildDots();
          updateArrows();
          currentIndex = Math.min(currentIndex, totalSlides() - 1);
          goToSlide(currentIndex);
        }, 150);
      });

      /* سحب باللمس - pointer events تعمل مع اللمس والماوس بدون تعارض مع الأسهم/النقاط */
      var startX = 0, delta = 0, dragStartTransform = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.target.closest('a, button')) return;
        isDragging = true;
        startX = e.clientX;
        delta = 0;
        clearInterval(autoplayTimer);
        track.style.transition = 'none';
        track.setPointerCapture && track.setPointerCapture(e.pointerId);
      });
      track.addEventListener('pointermove', function (e) {
        if (!isDragging) return;
        delta = e.clientX - startX;
      });
      function endDrag() {
        if (!isDragging) return;
        isDragging = false;
        track.style.transition = '';
        if (Math.abs(delta) > 40) {
          goToSlide(currentIndex + (delta < 0 ? 1 : -1));
        } else {
          goToSlide(currentIndex);
        }
        delta = 0;
        resetAutoplay();
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', function () { if (isDragging) endDrag(); });
    }

    function activateCategory(index) {
      cards.forEach(function (c) { c.classList.toggle('is-active', parseInt(c.dataset.index) === index); });
      if (filterEnabled) {
        panels.forEach(function (p) {
          var match = parseInt(p.dataset.panelIndex) === index;
          p.hidden = !match;
          p.classList.toggle('is-active', match);
        });
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        activateCategory(parseInt(card.dataset.index));
      });
      card.setAttribute('tabindex', '0');
      card.setAttribute('role', 'button');
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
      });
    });

    root._gcsc3Cleanup = function () { clearInterval(autoplayTimer); };
  }

  function initAll() {
    document.querySelectorAll('.gcsc3-section').forEach(function (el) { initGCSC3(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.gcsc3-section') : null;
    if (root) { root.dataset.gcsc3Init = ''; initGCSC3(root); }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.gcsc3-section') : null;
    if (root && root._gcsc3Cleanup) root._gcsc3Cleanup();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
